import { SelectField } from '../../../shared/form/inputs/SelectField';
import React from 'react';
import { range } from 'lodash';
import { charFromInteger } from '../../../helpers/stringHelpers';

type Props = {
  name: string;
  label: string | null;
};

const alphabetToM = range(1, 14).map(a => charFromInteger(a));
const numbers0To20 = range(0, 21).map(a => a.toString());
const labelRevision = (revision: string) => `REV ${revision}`;

export const RevisionSelectField = ({ name, label }: Props) => {
  return (
    <SelectField
      name={name}
      label={label}
      options={[
        {
          text: '—',
          value: '',
        },
        ...numbers0To20.map(number => ({
          text: labelRevision(number),
          value: labelRevision(number),
        })),
        { text: labelRevision('OR'), value: labelRevision('OR') },
        ...alphabetToM.map(character => ({
          text: labelRevision(character),
          value: labelRevision(character),
        })),
        {
          text: 'TEST',
          value: 'TEST',
        },
      ]}
    />
  );
};
